/**
 * Created by neo on 22.12.22.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { ExploreEntry } from '../../Model/Explore/ExploreEntry';
import { OnlineMeetingEntry } from '../../Model/Explore/OnlineMeetingEntry';
import { ExploreEntryRendererOnlineMeeting } from './ExploreEntryRendererOnlineMeeting';
import { ArticleEntry } from '../../Model/Explore/ArticleEntry';
import { ExploreEntryRendererArticle } from './ExploreEntryRendererArticle';
import { ActivityWorkoutEntry } from '../../Model/Explore/ActivityWorkoutEntry';
import { ExploreEntryRendererActivityWorkout } from './ExploreEntryRendererActivityWorkout';
import { ExploreEntryContainerProps } from './ExploreEntryContainer';
import { WebinarEntry } from '../../Model/Explore/WebinarEntry';
import { Recipe } from '../../Model/Diet/Recipe/Recipe';
import { ExploreEntryRendererRecipe } from './ExploreEntryRendererRecipe';
import { BreathingEntry } from '../../Model/Explore/BreathingEntry';
import { ExploreEntryRendererBreathing } from './ExploreEntryRendererBreathing';
import { MeditationEntry } from '../../Model/Explore/MeditationEntry';
import { ExploreEntryRendererMeditation } from './ExploreEntryRendererMeditation';
import { WorkoutTemplateEntry } from '../../Model/Explore/WorkoutTemplateEntry';
import { ExploreEntryRendererWorkoutTemplate } from './ExploreEntryRendererWorkoutTemplate';

export type ExploreCardEntryRendererProps = Omit<ExploreEntryContainerProps, 'entry'> & {
  entry: ExploreEntry | Recipe;
};

export const ExploreCardEntryRenderer: React.FC<ExploreCardEntryRendererProps> = observer(({ entry, ...moreProps }) => {
  if (entry.type === 'onlineMeeting') {
    return <ExploreEntryRendererOnlineMeeting entry={entry as OnlineMeetingEntry} {...moreProps} />;
  } else if (entry.type === 'article') {
    return <ExploreEntryRendererArticle entry={entry as ArticleEntry} {...moreProps} />;
  } else if (entry.type === 'activityWorkout') {
    return <ExploreEntryRendererActivityWorkout entry={entry as ActivityWorkoutEntry} {...moreProps} />;
  } else if (entry.type === 'webinar') {
    return <ExploreEntryRendererOnlineMeeting entry={entry as WebinarEntry} {...moreProps} />;
  } else if (entry.type === 'recipe') {
    return <ExploreEntryRendererRecipe entry={entry as Recipe} {...moreProps} />;
  } else if (entry.type === 'breathing') {
    return <ExploreEntryRendererBreathing entry={entry as BreathingEntry} {...moreProps} />;
  } else if (entry.type === 'meditation') {
    return <ExploreEntryRendererMeditation entry={entry as MeditationEntry} {...moreProps} />;
  } else if (entry.type === 'workoutTemplate') {
    return <ExploreEntryRendererWorkoutTemplate entry={entry as WorkoutTemplateEntry} {...moreProps} />;
  }

  return null;
});
